import { render, staticRenderFns } from "./FreeDesksTab.vue?vue&type=template&id=aa74e924&scoped=true&"
import script from "./FreeDesksTab.vue?vue&type=script&lang=js&"
export * from "./FreeDesksTab.vue?vue&type=script&lang=js&"
import style0 from "./FreeDesksTab.vue?vue&type=style&index=0&id=aa74e924&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa74e924",
  null
  
)

export default component.exports